import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, FilmIcon, UserIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { HomeIcon as HomeSolidIcon, FilmIcon as FilmSolidIcon, UserIcon as UserSolidIcon, MagnifyingGlassIcon as MagnifyingGlassSolidIcon } from '@heroicons/react/24/solid';

const Navbar = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/',
      label: 'Home',
      OutlineIcon: HomeIcon,
      SolidIcon: HomeSolidIcon
    },
    {
      path: '/shorts',
      label: 'Shorts',
      OutlineIcon: FilmIcon,
      SolidIcon: FilmSolidIcon
    },
    // {
    //   path: '/search',
    //   label: 'Search',
    //   OutlineIcon: MagnifyingGlassIcon,
    //   SolidIcon: MagnifyingGlassSolidIcon
    // },
    {
      path: '/profile',
      label: 'Profile',
      OutlineIcon: UserIcon,
      SolidIcon: UserSolidIcon
    }
  ];

  return (
    <nav className="fixed bottom-0 w-full bg-zinc-900/90 backdrop-blur-md border-t border-zinc-800 py-2 px-4 z-50">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map(item => {
          const isActive = location.pathname === item.path;
          const Icon = isActive ? item.SolidIcon : item.OutlineIcon;
          
          return (
            <Link 
              key={item.path}
              to={item.path} 
              className={`flex flex-col items-center p-2 ${
                isActive 
                  ? 'text-pink-500' 
                  : 'text-zinc-400 hover:text-zinc-200'
              } transition-colors duration-200`}
            >
              <div className={`relative ${isActive ? 'scale-110' : ''} transition-transform duration-200`}>
                <Icon className="h-6 w-6" />
                {isActive && (
                  <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"></span>
                )}
              </div>
              <span className="text-xs mt-1 font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Navbar; 